import {ApiEndpointUrl} from "../../common";
export const ordersPoint = { list: ApiEndpointUrl+ "orders" };
